<template>

      <li role="none" >

        <button  :title="node.name" role="menuitem" v-if="node.children.length > 0">
          <span >{{node.name}}</span>
          <mcc-icon name="forward" aria-hidden="true" ></mcc-icon>
        </button>
        <button @click="viewProcesses(node)" :title="node.name" role="menuitem" v-else>
          <span >{{node.name}}</span>
        </button>
        <div class="mcc-drilldown-submenu" v-if="node.children.length > 0">
        <ul  role="menu">
          <li role="none" >
          <button class="mcc-button nav-button mcc-button--sm mcc-button--outline" style="border-color: #a5a5b6 !important; border: solid #a5a5b6 !important; border-width: 1px !important;" @click="viewProcesses(node)" v-if="node.children != null && node.children.length > 0" title="View processes">
            <span >View processes</span></button>
            </li>
            <div class="mu-border-bottom mu-my-03" ></div>
            <DrilldownItem  v-for="(childNode, childIndex) in node.children" :key="childIndex" :node="childNode"></DrilldownItem>
        </ul>
      </div>
      </li>
  </template>



<script>
import Drilldown from './Drilldown.vue';
export default {
    name: 'DrilldownItem',
    components: {
        Drilldown
    },
    props: ['node', 'label'],
    created() { },
    mounted() {
        $('.classToRemove').each(function (ele) {
            let childs = $(this).children();
            $(childs).insertAfter($(this));
        });
    },
    data() {
        return {
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            isSubMenuOpen: false,

        }
    },
    methods: {
        
        viewProcesses(buttonNode) {
            if (buttonNode.children.length > 0) {
        this.isSubMenuOpen = !this.isSubMenuOpen;
      }
            this.$router.push(
                this.CONTEXT_PATH +
                "/category/view/" +
                buttonNode.name
            );
        },
      
    },
}
</script>
